var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9706 2.61358C4.40542 2.76502 3.89005 3.06257 3.47631 3.47631C3.06257 3.89005 2.76502 4.40542 2.61358 4.9706",
    stroke: "#454444",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0294 2.61358C15.5946 2.76502 16.1099 3.06257 16.5237 3.47631C16.9374 3.89005 17.235 4.40542 17.3864 4.9706",
    stroke: "#454444",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 16.6673C13.6818 16.6673 16.6666 13.6825 16.6666 10.0007C16.6666 6.31875 13.6818 3.33398 9.99992 3.33398C6.31802 3.33398 3.33325 6.31875 3.33325 10.0007C3.33325 13.6825 6.31802 16.6673 9.99992 16.6673ZM10.9999 6.66732C10.9999 6.11503 10.5522 5.66732 9.99992 5.66732C9.44763 5.66732 8.99992 6.11503 8.99992 6.66732V9.75065C8.99992 10.441 9.55956 11.0007 10.2499 11.0007H12.4999C13.0522 11.0007 13.4999 10.5529 13.4999 10.0007C13.4999 9.44837 13.0522 9.00065 12.4999 9.00065H10.9999V6.66732Z",
    fill: "#454444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFill);
export default __webpack_public_path__ + "static/media/Clock_fill.a239afa9678dcaadb0d98932377297e2.svg";
export { ForwardRef as ReactComponent };